'use client';

import FormText from '@/components/form/FormText/FormText';
import { FaqSearchForm as CommonFaqSearchForm } from '@monorepo/common';

function FaqSearchForm() {
  return <CommonFaqSearchForm FormTextComponent={FormText} />;
}

export default FaqSearchForm;
